import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import {getCaptcha, requestPassword, requestPasswordSubmit} from '../core/_requests'
import {KTSVG} from "../../../../_metronic/helpers";

const initialValues = {
    mobile: '',
    captcha: ''
}
const initialValueSubmit = {
    token: '',

    captcha: '',
    newPassword: ''
}
const forgotPasswordSchema = Yup.object().shape({
    mobile: Yup.string()
        .min(11, 'شماره تماس وارد شده معتبر نمیباشد')
        .max(11, 'شماره تماس وارد شده معتبر نمیباشد')
        .required('شماره تماس اجباری میباشد'),
    captcha: Yup.string()
        .min(4, ' تصویر امنیتی وارد شده معتبر نمیباشد')
        .max(4, 'تصویر امنیتی وارد شده معتبر نمیباشد')
        .required('تصویر امنیتی اجباری میباشد'),
})
const SubmitPasswordSchema = Yup.object().shape({

    captcha: Yup.string()
        .min(4, ' تصویر امنیتی وارد شده معتبر نمیباشد')
        .max(4, 'تصویر امنیتی وارد شده معتبر نمیباشد')
        .required('تصویر امنیتی اجباری میباشد'),
    token: Yup.string()
        .min(4, ' کد امنیتی وارد شده معتبر نمیباشد')
        .max(4, 'کد امنیتی وارد شده معتبر نمیباشد')
        .required('کد امنیتی اجباری میباشد'),
    newPassword: Yup.string()
        .min(6, ' کلمه عبور وارد شده معتبر نمیباشد')
        .max(10, 'کلمه عبور وارد شده معتبر نمیباشد')
        .required('کلمه عبور اجباری میباشد'),
})

export function ForgotPassword() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
    const [captcha, setCaptcha] = useState("");
    const formik = useFormik({
        initialValues,
        validationSchema: forgotPasswordSchema,
        onSubmit: (values, {setStatus, setSubmitting}) => {
            setLoading(true)
            setHasErrors(undefined)
            setTimeout(() => {
                requestPassword(values.mobile, values.captcha)
                    .then(({data: {result}}) => {
                        // setIsSubmitMobile(true);
                        setHasErrors(false);
                        setLoading(false);
                        navigate(`/auth/submit-forgot-password?mobile=${values.mobile}`)
                    })
                    .catch((err : any) => {
                        setHasErrors(true)
                        setLoading(false)
                        setSubmitting(false)
                        setStatus('اطلاعات وارد شده معتبر نمیباشد')
                    })
            }, 0)
        },
    })
    async function refreshCaptcha() {
        try {
            const {data: captchaData} = await getCaptcha();
            setCaptcha(captchaData);
        } catch {

        }
    }
    useEffect(() => {
            refreshCaptcha()
        },
        [])
    return (
        <>
            <form
                className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
                noValidate
                id='kt_login_password_reset_form'
                onSubmit={formik.handleSubmit}
            >
                <div className='text-center mb-10'>
                    {/* begin::Title */}
                    <h1 className='text-dark mb-3'>بازیابی رمز عبور</h1>
                    {/* end::Title */}

                    {/* begin::Link */}
                    <div className='text-gray-400 fw-semibold fs-4'>لطفاً شماره موبایلی که با آن ثبت نام کرده اید
                        وارد
                        نمایید .
                    </div>
                    {/* end::Link */}
                </div>

                {/* begin::Title */}
                {hasErrors === true && (
                    <div className='mb-lg-15 alert alert-danger'>
                        <div className='alert-text font-weight-bold'>
                            اطلاعات وارد شده معتبر نمیباشد ، لطفاً مجددا تلاش نمایید
                        </div>
                    </div>
                )}

                {hasErrors === false && (
                    <div className='mb-10 bg-light-info p-8 rounded'>
                        <div className='text-info'>کد امنیتی جهت بروز رسانی رمز عبور به شماره تماس شما ارسال گردید
                        </div>
                    </div>
                )}
                {/* end::Title */}

                {/* begin::Form group */}
                <div className='fv-row mb-10'>
                    <label className='form-label fw-bold text-gray-900 fs-6'>شماره تماس </label>
                    <input
                        type='text'
                        placeholder=''
                        autoComplete='off'
                        {...formik.getFieldProps('mobile')}
                        className={clsx(
                            'form-control form-control-lg form-control-solid',
                            {'is-invalid': formik.touched.mobile && formik.errors.mobile},
                            {
                                'is-valid': formik.touched.mobile && !formik.errors.mobile,
                            }
                        )}
                    />
                    {formik.touched.mobile && formik.errors.mobile && (
                        <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                                <span role='alert'>{formik.errors.mobile}</span>
                            </div>
                        </div>
                    )}
                </div>
                {/* end::Form group */}

                {/* begin::Form group */}
                <div className='fv-row mb-10 row'>
                    <div className="col-6">
                        <label className='form-label fs-6 fw-bold text-dark'>تصویر امنیتی</label>

                        <input
                            placeholder='تصویر امنیتی '
                            {...formik.getFieldProps('captcha')}
                            className={clsx(
                                'form-control form-control-lg form-control-solid ',
                                {'is-invalid': formik.touched.captcha && formik.errors.captcha},
                                {
                                    'is-valid': formik.touched.captcha && !formik.errors.captcha,
                                }
                            )}
                            type='text'
                            name='captcha'
                            autoComplete='off'
                        />
                        {formik.touched.captcha && formik.errors.captcha && (
                            <div className='fv-plugins-message-container'>
                                <span role='alert'>{formik.errors.captcha}</span>
                            </div>
                        )}
                    </div>

                    <div className="col-6 ">
                        <label className='form-label fs-6 fw-bold text-dark'>تصویر </label>
                        <div className="row">
                            <div className="col-8">
                                <img src={captcha} className="col-8" alt=""/>
                            </div>
                            <div className="col-4">
                                <button onClick={refreshCaptcha} className="btn btn-light-primary me-3">

                                    <KTSVG path='/media/icons/duotune/arrows/arr029.svg' className='svg-icon-2'/>

                                </button>
                            </div>

                        </div>


                    </div>

                </div>
                {/* end::Form group */}


                {/* begin::Form group */}
                <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
                    <button
                        type='submit'
                        id='kt_password_reset_submit'
                        className='btn btn-lg btn-primary fw-bold me-4'
                    >
                        <span className='indicator-label'>تایید</span>
                        {loading && (
                            <span className='indicator-progress'>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
                        )}
                    </button>
                    <Link to='/auth/login'>
                        <button
                            type='button'
                            id='kt_login_password_reset_form_cancel_button'
                            className='btn btn-lg btn-light-primary fw-bold'
                            disabled={formik.isSubmitting || !formik.isValid}
                        >
                            لغو
                        </button>
                    </Link>{' '}
                </div>
                {/* end::Form group */}
            </form>

        </>
    )
}
